// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__pteGk","detailsBorder":"styles_detailsBorder__2EiAo"};